import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Router } from '@angular/router';

@Component({
  selector: 'primary-care-provider-popup',
  templateUrl: './primary-care-provider-popup.component.html',
  styleUrls: ['./primary-care-provider-popup.component.scss'],
})
export class PrimaryCareProviderPopupComponent  implements OnInit {

  @ViewChild(TooltipDirective)
  public tooltipDir!: TooltipDirective;

  @Output() closePhysicain: EventEmitter<boolean> = new EventEmitter<boolean>();
  constructor( private deviceService: DeviceDetectorService, private router: Router) {
    this.epicFunction();
   }

  ngOnInit() {}
  
  public referalData = [
    {
      prefix: 'Mr',
      firstName: 'Khaled',
      middleName: 'Elias Jiries',
      lastName: 'Abawi',
      Address: 'Nashik.',
      phone: '123-456-7890',
      specialty: 'Retail',
    },
    {
      prefix: 'Mr',
      firstName: 'Miguel',
      middleName: 'E',
      lastName: 'Allen',
      Address: '1168 Heavner Court.',
      phone: '123-456-7890',
      specialty: 'Retail',
    },
    {
      prefix: 'Dr',
      firstName: 'Kowalski',
      middleName: '',
      lastName: 'Andrew',
      Address: '1168 Heavner Court.',
      phone: '123-456-7890',
      specialty: 'Retail',
    },
    {
      prefix: 'Mr',
      firstName: 'Khaled',
      middleName: 'Elias Jiries',
      lastName: 'Abawi',
      Address: 'Nashik.',
      phone: '123-456-7890',
      specialty: 'Retail',
    },
    {
      prefix: 'Mr',
      firstName: 'Miguel',
      middleName: 'E',
      lastName: 'Allen',
      Address: '1168 Heavner Court.',
      phone: '123-456-7890',
      specialty: 'Retail',
    },
    {
      prefix: 'Dr',
      firstName: 'Kowalski',
      middleName: '',
      lastName: 'Andrew',
      Address: '1168 Heavner Court.',
      phone: '123-456-7890',
      specialty: 'Retail',
    },
    {
      prefix: 'Mr',
      firstName: 'Khaled',
      middleName: 'Elias Jiries',
      lastName: 'Abawi',
      Address: 'Nashik.',
      phone: '123-456-7890',
      specialty: 'Retail',
    },
    {
      prefix: 'Mr',
      firstName: 'Miguel',
      middleName: 'E',
      lastName: 'Allen',
      Address: '1168 Heavner Court.',
      phone: '123-456-7890',
      specialty: 'Retail',
    },
    {
      prefix: 'Dr',
      firstName: 'Kowalski',
      middleName: '',
      lastName: 'Andrew',
      Address: '1168 Heavner Court.',
      phone: '123-456-7890',
      specialty: 'Retail',
    },
    {
      prefix: 'Mr',
      firstName: 'Khaled',
      middleName: 'Elias Jiries',
      lastName: 'Abawi',
      Address: 'Nashik.',
      phone: '123-456-7890',
      specialty: 'Retail',
    },
    {
      prefix: 'Mr',
      firstName: 'Miguel',
      middleName: 'E',
      lastName: 'Allen',
      Address: '1168 Heavner Court.',
      phone: '123-456-7890',
      specialty: 'Retail',
    },
    {
      prefix: 'Dr',
      firstName: 'Kowalski',
      middleName: '',
      lastName: 'Andrew',
      Address: '1168 Heavner Court.',
      phone: '123-456-7890',
      specialty: 'Retail',
    },
    {
      prefix: 'Mr',
      firstName: 'Khaled',
      middleName: 'Elias Jiries',
      lastName: 'Abawi',
      Address: 'Nashik.',
      phone: '123-456-7890',
      specialty: 'Retail',
    },
    {
      prefix: 'Mr',
      firstName: 'Miguel',
      middleName: 'E',
      lastName: 'Allen',
      Address: '1168 Heavner Court.',
      phone: '123-456-7890',
      specialty: 'Retail',
    },
    {
      prefix: 'Dr',
      firstName: 'Kowalski',
      middleName: '',
      lastName: 'Andrew',
      Address: '1168 Heavner Court.',
      phone: '123-456-7890',
      specialty: 'Retail',
    },
    {
      prefix: 'Mr',
      firstName: 'Khaled',
      middleName: 'Elias Jiries',
      lastName: 'Abawi',
      Address: 'Nashik.',
      phone: '123-456-7890',
      specialty: 'Retail',
    },
    {
      prefix: 'Mr',
      firstName: 'Miguel',
      middleName: 'E',
      lastName: 'Allen',
      Address: '1168 Heavner Court.',
      phone: '123-456-7890',
      specialty: 'Retail',
    },
    {
      prefix: 'Dr',
      firstName: 'Kowalski',
      middleName: '',
      lastName: 'Andrew',
      Address: '1168 Heavner Court.',
      phone: '123-456-7890',
      specialty: 'Retail',
    },
    {
      prefix: 'Mr',
      firstName: 'Khaled',
      middleName: 'Elias Jiries',
      lastName: 'Abawi',
      Address: 'Nashik.',
      phone: '123-456-7890',
      specialty: 'Retail',
    },
    {
      prefix: 'Mr',
      firstName: 'Miguel',
      middleName: 'E',
      lastName: 'Allen',
      Address: '1168 Heavner Court.',
      phone: '123-456-7890',
      specialty: 'Retail',
    },
    {
      prefix: 'Dr',
      firstName: 'Kowalski',
      middleName: '',
      lastName: 'Andrew',
      Address: '1168 Heavner Court.',
      phone: '123-456-7890',
      specialty: 'Retail',
    },
    {
      prefix: 'Mr',
      firstName: 'Khaled',
      middleName: 'Elias Jiries',
      lastName: 'Abawi',
      Address: 'Nashik.',
      phone: '123-456-7890',
      specialty: 'Retail',
    },
    {
      prefix: 'Mr',
      firstName: 'Miguel',
      middleName: 'E',
      lastName: 'Allen',
      Address: '1168 Heavner Court.',
      phone: '123-456-7890',
      specialty: 'Retail',
    },
    {
      prefix: 'Dr',
      firstName: 'Kowalski',
      middleName: '',
      lastName: 'Andrew',
      Address: '1168 Heavner Court.',
      phone: '123-456-7890',
      specialty: 'Retail',
    }
  ]

  public showTooltip(e: MouseEvent): void {
    const element = e.target as HTMLElement;
    if (
      (element.nodeName === "TD" || element.className === "k-column-title") &&
      element.offsetWidth < element.scrollWidth
    ) {
      this.tooltipDir.toggle(element);
    } else {
      this.tooltipDir.hide();
    }
  }

  closePhysicainPopup(){
    this.closePhysicain.emit(true);
    if(this.isMobile){
      this.router.navigate(['app/info-edit']);
    }
  }
  isMobile!: boolean;
  isTablet!: boolean;
  isDesktopDevice!: boolean;
  osType!: string;
  deviceInfo: import("ngx-device-detector").DeviceInfo | undefined;
  isIOS!: boolean ;
  isAndroid!: boolean ;
  epicFunction(){
    this.deviceInfo = this.deviceService.getDeviceInfo();
    this.isMobile = this.deviceService.isMobile();
    this.isTablet = this.deviceService.isTablet();
    this.isDesktopDevice = this.deviceService.isDesktop();
    // this.osType = this.deviceInfo.os;
    // console.log(this.deviceInfo);
    // console.log("Mobile" + this.isMobile);  // returns if the device is a mobile device (android / iPhone / windows-phone etc)
    // console.log("Tablet" + this.isTablet);  // returns if the device us a tablet (iPad etc)
    // console.log("Desktop" + this.isDesktopDevice); // returns if the app is running on a Desktop browser.
    // console.log("OS" + this.osType); // returns if the app is running on a Desktop browser.
    // if(this.isMobile == true && this.osType == 'iOS'){
    //   this.isIOS = true;
    // }
    // if(this.isMobile == true && this.osType == 'Android'){
    //   this.isAndroid = true;
    // }
  }

}
